import React from 'react';
import { Route } from 'react-router-dom';
import { PrivateRoute } from '../components/auth';

/**
 * Route utilities for creating consistent route patterns
 */

/**
 * Create a protected route that requires authentication
 * @param {string} path - Route path
 * @param {React.Component} Component - Component to render
 * @param {object} additionalProps - Additional props to pass to the route
 * @returns {React.Element} Protected route element
 */
export const createProtectedRoute = (path, Component, additionalProps = {}) => (
    <Route 
        key={path}
        path={path} 
        element={
            <PrivateRoute>
                <Component />
            </PrivateRoute>
        }
        {...additionalProps}
    />
);

/**
 * Create a standard route without protection
 * @param {string} path - Route path
 * @param {React.Component} Component - Component to render
 * @param {object} additionalProps - Additional props to pass to the route
 * @returns {React.Element} Route element
 */
export const createRoute = (path, Component, additionalProps = {}) => (
    <Route 
        key={path}
        path={path} 
        element={<Component />}
        {...additionalProps}
    />
);

export default {
    createProtectedRoute,
    createRoute
};